export default "__VITE_ASSET__DmopGI8$__"